/**
 * About Page
 * 会社について - 代表挨拶、企業理念、会社情報
 */

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Page Header with Background Image */}
      <section className="relative py-32 border-b border-gray-200 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="/assets/images/consultation_area.jpeg"
            alt="About"
            className="w-full h-full object-cover object-center"
          />
          {/* Modern orange overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-rs-orange/30 to-rs-orange/50 mix-blend-multiply"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/20 to-white/90"></div>
        </div>
        <div className="container-custom relative z-10">
          <h1 className="text-5xl md:text-6xl font-bold mb-4 animate-fade-in text-rs-gray-dark">
            会社について
          </h1>
          <p className="text-xl text-gray-600 animate-slide-up font-light tracking-wider">
            ABOUT OUR COMPANY
          </p>
        </div>
      </section>

      {/* 代表挨拶 */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold mb-12 text-center text-rs-gray-dark">
              代表<span className="text-rs-orange">挨拶</span>
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
              {/* Image with modern overlay */}
              <div className="relative rounded-2xl overflow-hidden h-full min-h-[400px] lg:min-h-[600px] order-2 lg:order-1">
                <img
                  src="/assets/images/futuristic_dealmaking.jpeg"
                  alt="代表挨拶"
                  className="w-full h-full object-cover object-center"
                />
                {/* Subtle orange gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-br from-rs-orange/20 via-transparent to-rs-orange/30 mix-blend-multiply"></div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              </div>

              {/* Text Content */}
              <div className="bg-white border border-gray-200 p-8 md:p-12 rounded-2xl order-1 lg:order-2">
                <div className="prose prose-lg max-w-none">
                  <p className="text-gray-700 leading-relaxed mb-6">
                    株式会社RSの黒木です。
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-6">
                    現在のお仕事は、心から楽しんで取り組めていますか？<br /><br />
                    株式会社RSでは、スタッフ同士の円滑なコミュニケーションを大切にし、社員が安心して働ける職場環境の整備に努めています。なぜなら、私たちの人生の大部分は仕事の時間だからです。その時間を楽しく過ごせれば、人生全体の満足感もきっと向上すると考えています。
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-6">
                    具体的には、週休2日以上（8日から10日の休暇）を確保し、仕事のストレスをできるだけ減らすことに努めています。これにより、休日には趣味や家族・友人と過ごす時間を増やし、リフレッシュできる環境を整えています。これが、仕事だけでなく私生活も充実させるポイントです。
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    もし今の自分の働き方や生活に満足していない、自分らしい生活や仕事のスタイルを見つけたいと感じている方がいれば、ぜひ一緒に新しい未来を築きませんか。私たちと一緒に、より豊かで充実した、楽しい人生を目指していきましょう。
                  </p>
                </div>

                <div className="mt-8 pt-8 border-t border-gray-200">
                  <p className="text-gray-600 text-sm">株式会社RS</p>
                  <p className="text-2xl font-bold text-rs-black">代表取締役 黒木智隆</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 企業理念 */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <h2 className="text-4xl font-bold mb-12 text-center text-rs-gray-dark">
            企業<span className="text-rs-orange">理念</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="bg-white border border-gray-200 p-8 rounded-2xl hover:shadow-lg hover:border-rs-orange/30 transition-all duration-300">
              <div className="text-rs-orange text-4xl font-bold mb-4">01</div>
              <h3 className="text-xl font-bold mb-4 text-rs-gray-dark">顧客第一</h3>
              <p className="text-gray-500 leading-relaxed text-sm">
                お客様の真のニーズを理解し、
                最適なソリューションを提供することで、
                信頼と満足を築きます。
              </p>
            </div>

            <div className="bg-white border border-gray-200 p-8 rounded-2xl hover:shadow-lg hover:border-rs-orange/30 transition-all duration-300">
              <div className="text-rs-orange text-4xl font-bold mb-4">02</div>
              <h3 className="text-xl font-bold mb-4 text-rs-gray-dark">挑戦と成長</h3>
              <p className="text-gray-500 leading-relaxed text-sm">
                常に現状に満足せず、新しい挑戦を通じて
                個人と組織の持続的な成長を追求します。
              </p>
            </div>

            <div className="bg-white border border-gray-200 p-8 rounded-2xl hover:shadow-lg hover:border-rs-orange/30 transition-all duration-300">
              <div className="text-rs-orange text-4xl font-bold mb-4">03</div>
              <h3 className="text-xl font-bold mb-4 text-rs-gray-dark">チームワーク</h3>
              <p className="text-gray-500 leading-relaxed text-sm">
                互いを尊重し、協力し合うことで、
                一人では成し遂げられない価値を創造します。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 会社情報 */}
      <section className="section-padding">
        <div className="container-custom">
          <h2 className="text-4xl font-bold mb-12 text-center text-rs-gray-dark">
            会社<span className="text-rs-orange">情報</span>
          </h2>

          <div className="max-w-3xl mx-auto bg-white border border-gray-200 rounded-2xl overflow-hidden">
            {/* Mobile: stacked layout, Desktop: table layout */}
            <div className="divide-y divide-gray-200">
              <div className="flex flex-col md:flex-row md:items-center border-b border-gray-200">
                <div className="px-4 md:px-8 pt-4 pb-2 md:py-6 font-bold text-gray-700 bg-white md:w-1/3">
                  会社名
                </div>
                <div className="px-4 md:px-8 pb-4 pt-0 md:py-6 text-gray-600">株式会社RS</div>
              </div>
              <div className="flex flex-col md:flex-row md:items-start border-b border-gray-200">
                <div className="px-4 md:px-8 pt-4 pb-2 md:py-6 font-bold text-gray-700 bg-white md:w-1/3">
                  事業内容
                </div>
                <div className="px-4 md:px-8 pb-4 pt-0 md:py-6 text-gray-600">
                  通信事業（家電量販店、催事場、ショップイベントでの声かけ & 提案）
                </div>
              </div>
              <div className="flex flex-col md:flex-row md:items-center border-b border-gray-200">
                <div className="px-4 md:px-8 pt-4 pb-2 md:py-6 font-bold text-gray-700 bg-white md:w-1/3">
                  設立
                </div>
                <div className="px-4 md:px-8 pb-4 pt-0 md:py-6 text-gray-600">2025年</div>
              </div>
              <div className="flex flex-col md:flex-row md:items-center border-b border-gray-200">
                <div className="px-4 md:px-8 pt-4 pb-2 md:py-6 font-bold text-gray-700 bg-white md:w-1/3">
                  代表者
                </div>
                <div className="px-4 md:px-8 pb-4 pt-0 md:py-6 text-gray-600">黒木智隆</div>
              </div>
              <div className="flex flex-col md:flex-row md:items-center border-b border-gray-200">
                <div className="px-4 md:px-8 pt-4 pb-2 md:py-6 font-bold text-gray-700 bg-white md:w-1/3">
                  従業員数
                </div>
                <div className="px-4 md:px-8 pb-4 pt-0 md:py-6 text-gray-600">2名</div>
              </div>
              <div className="flex flex-col md:flex-row md:items-center border-b border-gray-200">
                <div className="px-4 md:px-8 pt-4 pb-2 md:py-6 font-bold text-gray-700 bg-white md:w-1/3">
                  所在地
                </div>
                <div className="px-4 md:px-8 pb-4 pt-0 md:py-6 text-gray-600">福岡県北九州市八幡西区茶売町10-15-203</div>
              </div>
              <div className="flex flex-col md:flex-row md:items-center">
                <div className="px-4 md:px-8 pt-4 pb-2 md:py-6 font-bold text-gray-700 bg-white md:w-1/3">
                  電話番号
                </div>
                <div className="px-4 md:px-8 pb-4 pt-0 md:py-6 text-gray-600">070-7581-7865</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
